export default __webpack_public_path__ + "static/media/inventure.41e06e91.JPG";